// removed by extract-text-webpack-plugin
module.exports = {"chosenCourierWrap":"qempo_CourierInfo_chosenCourierWrap-2zVhMG1","courierInfoWrap":"qempo_CourierInfo_courierInfoWrap-3AH0gTA","textWrap":"qempo_CourierInfo_textWrap-3WWs5q0","courierName":"qempo_CourierInfo_courierName-2GAL9UA","price":"qempo_CourierInfo_price-1otV4mI","shippingDays":"qempo_CourierInfo_shippingDays-1SrDCsV","infoWrap":"qempo_CourierInfo_infoWrap-1_nzsKR"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/CourierInfo/CourierInfo.scss
// module id = 1717
// module chunks = 0